


























































































import { Vue, Component } from "vue-property-decorator";
import VueSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min.js";
import "vue-slider-component/dist-css/vue-slider-component.css";
import "vue-slider-component/theme/default.css";
import SkeletonLoader from "@/modules/externals/components/SkeletonLoader.vue";
import { Action, namespace } from "vuex-class";
import {
  AutoApprovePayload,
  ToggleThresholdPayload,
  UpdateThresholdValuePayload,
  ConfigureAutoApprove,
  ToggleThresholdReviewPayload,
  UpdateRetentionDaysPayload,
} from "../types";
const AutomationNamespace = namespace("automation");

@Component({
  components: {
    VueSlider,
    "skeleton-loader": SkeletonLoader,
  },
})
export default class Automation extends Vue {
  @Action("automation/toggleThreshold") toggleThreshold!: (
    payload: ToggleThresholdPayload
  ) => Promise<{}>;

  @Action("automation/toggleThresholdReview") toggleThresholdReview!: (
    payload: ToggleThresholdReviewPayload
  ) => Promise<{}>;


  @Action("automation/updateThresholdValue") updateThresholdValue!: (
    payload: UpdateThresholdValuePayload
  ) => Promise<{}>;
  @Action("automation/updateThresholdFacialValue") updateThresholdFacialValue!: (
    payload: UpdateThresholdValuePayload
  ) => Promise<{}>;

  @Action("automation/updateRetentionDaysValue") updateRetentionDaysValue!: (
    payload: UpdateRetentionDaysPayload
  ) => Promise<{}>;


  @Action("automation/configureAutoApprove") configureAutoApprove!: (
    payload: AutoApprovePayload
  ) => Promise<{}>;
  @Action("automation/initializeThreshold")
  initializeThreshold!: () => Promise<{}>;
  @AutomationNamespace.Getter("getThreshold") threshold;
  @AutomationNamespace.Getter("getThresholdFacial") thresholdFacial;
  @AutomationNamespace.Getter("isEnabled") enabled;
  @AutomationNamespace.Getter("isEnabledReview") enabledReview;
  @AutomationNamespace.Getter("getRetentionDays") retentionDays;

  @AutomationNamespace.Getter("isSuccessful") success;
  @AutomationNamespace.Getter("errorPresent") error;
  loading = false;
  isProfileLoading = false;
  options = {
    tooltipStyle: {
      opacity: "0",
    },
    railStyle: {
      width: "100%",
      height: "6px",
      backgroundColor: "#E8F1FB",
    },
    processStyle: {
      backgroundColor: "rgba(61, 113, 227, var(--bg-opacity))",
    },
    dotOptions: [
      {
        style: {
          width: "22px",
          height: "22px",
          background: "rgba(61, 113, 227, var(--bg-opacity))",
          border: "5px solid #002583",
          marginTop: "-5.5px",
        },
      },
    ],
  };

  async beforeMount() {
    this.isProfileLoading = true;
    await this.initializeThreshold();
    this.isProfileLoading = false;
  }

  update(event) {
    this.toggleThreshold({
      enabled: event.target.checked,
    });
  }

  updateReview(event) {
    this.toggleThresholdReview({
      enabledReview: event.target.checked,
    });
  }

  updateThreshold(newThreshold) {
    this.updateThresholdValue({ threshold: newThreshold });
  }

  updateThresholdFacial(newThreshold) {
    this.updateThresholdFacialValue({ thresholdFacial: newThreshold });
  }

  updateRetentionDays(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    const value = parseInt(inputElement.value, 10);
    const clampedValue = Math.min(30, Math.max(1, value));
    this.updateRetentionDaysValue({ retentionDays: clampedValue });


  }

  autoApprove() {
    this.loading = true;
    this.configureAutoApprove({
      threshold: this.threshold,
      enabled: this.enabled,
      enabledReview: this.enabledReview,
      thresholdFacial: this.thresholdFacial,
      retentionDays: this.retentionDays
    })
      .then((res: ConfigureAutoApprove) => {
        this.loading = false;
        const { isSuccessful } = res;
        if (isSuccessful) {
          this.$notify({
            group: "success",
            title: "Success",
            text: "Your changes have been saved",
          });
        } else {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Failed to save changes",
          });
        }
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
